import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';

// Components
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import QuoteRequestForm from './components/QuoteRequestForm';
import Modal from '@mui/material/Modal';
import Fab from '@mui/material/Fab';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import Values from './components/Values';
import TradeRoutes from './components/TradeRoutes';
import StrategicAdvantages from './components/StrategicAdvantages';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import NewsletterPage from './components/NewsletterPage';
import EventsPage from './components/EventsPage';
import SearchResults from './pages/SearchResults';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

function App() {
  const [openQuote, setOpenQuote] = useState(false);
  const handleOpenQuote = () => setOpenQuote(true);
  const handleCloseQuote = () => setOpenQuote(false);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={
              <>
                <About />
                <Values />
                <TradeRoutes />
                <StrategicAdvantages />
                <Services />
                <Contact />
              </>
            } />
            <Route path="/newsletter" element={<NewsletterPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/search" element={<SearchResults />} />
          </Routes>
        </main>
        <Footer />
        <BackToTop />
        {/* Floating button to open quote modal */}
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpenQuote}
          sx={{
            position: 'fixed',
            bottom: 32,
            right: 32,
            zIndex: 2000,
            borderRadius: 8,
            fontWeight: 700,
            fontSize: '1.15rem',
            px: 4,
            py: 1.5,
            boxShadow: '0 4px 24px #c9a74c44',
            background: '#c9a74c',
            color: '#181a20',
            '&:hover': {
              background: '#b8933d',
              color: '#fff',
            },
          }}
        >
          Request a Quote
        </Button>
        <Modal open={openQuote} onClose={handleCloseQuote} aria-labelledby="quote-modal-title" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Box sx={{ outline: 'none', maxWidth: 700, width: '98%', bgcolor: 'background.paper', borderRadius: 4, boxShadow: 24, p: { xs: 2, sm: 5 } }}>
            <QuoteRequestForm />
          </Box>
        </Modal>
      </div>
    </ThemeProvider>
  );
}

export default App; 